var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileTypePix(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.41667 17C1.03889 17 0.708333 16.8583 0.425 16.575C0.141667 16.2917 0 15.9611 0 15.5833V1.41667C0 1.03889 0.141667 0.708333 0.425 0.425C0.708333 0.141667 1.03889 0 1.41667 0H15.5833C15.9611 0 16.2917 0.141667 16.575 0.425C16.8583 0.708333 17 1.03889 17 1.41667V15.5833C17 15.9611 16.8583 16.2917 16.575 16.575C16.2917 16.8583 15.9611 17 15.5833 17H1.41667ZM1.41667 15.5833H15.5833V1.41667H1.41667V15.5833ZM2.73889 13.2931H14.2847L10.8139 8.66528L7.69722 12.7028L5.50139 9.70417L2.73889 13.2931Z",
    fill: "#BC0000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileTypePix);
export default __webpack_public_path__ + "static/media/file-type-pix.44e1b66538e71cd56a25b7286362870d.svg";
export { ForwardRef as ReactComponent };